import planModal from 'assets/themes/vacances-campings/js/page/product/modal/plan'

export default (): void => {
  planModal()
}
